import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';
import { MenuItem, Tooltip } from '@mui/material';
import { themecolors } from './../../Layout/theme';

const mapStateToProps = () => ({});

// Styling for the custom TextField
const CustomTextFieldRoot = styled(TextField)(({ multiSelect, rows }) => ({
  '& .MuiInputLabel-root': {
    marginTop: '-8px',
    fontSize: '12px',
    padding:"0px",
    '&.Mui-focused': {
      color: themecolors['500'],
      marginTop: '0',
    },
    '&.Mui-error': {
      color: themecolors['error'],
    },
    '&.MuiInputLabel-shrink': {
      marginTop: '0',
    },
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: themecolors['500'],
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: themecolors['error'] + ' !important',
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: multiSelect && rows ? '14px' : '12px',
    padding: '5px 14px',
    minHeight: '18px',
    height: 'auto',
    fontWeight: multiSelect && rows ? 400 : 'normal',
    color: multiSelect && rows ? 'black' : '#999'
  },
  '& .MuiOutlinedInput-multiline': {
    padding: '0',
    fontSize: '14px',
  },
  '& .MuiSelect-icon': {
    color: '#999',
  },
  '& .MuiPaper-root': {
    backgroundColor: themecolors['500'],
  },
}));

class CustomTextField extends React.Component {
  // Get tooltip text for selected multiple values
  getSelectedNames = () => {
    const { value, options } = this.props;
    const selectedArray = Array.isArray(value) ? value : [value];

    const selectedNames = options
      .filter(option => selectedArray.includes(option.key))
      .map(option => option.name);

    return selectedNames.join(', ');
  };

  render() {
    const { options, multiSelect, ...others } = this.props;

    return (
      <Tooltip
        title={multiSelect ? this.getSelectedNames() : ''}
        arrow
        disableHoverListener={!multiSelect}
        placement="right"
      >
        <div>
          <CustomTextFieldRoot
            {...others}
            select // This enables the dropdown
            variant="outlined"
            multiSelect={multiSelect ? 1 : 0} // passed to styled component
            value={this.props.value}
            onChange={this.props.onChange}
            SelectProps={{
              multiple: multiSelect, // true for multi-select
              MenuProps: {
                classes: {
                  paper: 'custom-menu-paper',
                },
              },
            }}
          >
            {options && options.map((option) => (
              <MenuItem key={option.key} value={option.key}>
                {option.name}
              </MenuItem>
            ))}
          </CustomTextFieldRoot>
        </div>
      </Tooltip>
    );
  }
}

CustomTextField.propTypes = {
  options: PropTypes.array.isRequired,   // dropdown items: [{ key, name }]
  value: PropTypes.any,                  // selected value(s)
  onChange: PropTypes.func,              // handler
  multiSelect: PropTypes.bool,           // true = multi-select mode
};

CustomTextField.defaultProps = {
  multiSelect: false,
};

export default connect(mapStateToProps)(CustomTextField);
